export default "__VITE_ASSET__336c626f__"